import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { readFile } from "utils";
import { PaziaFileDropzone } from "components/atoms";
import { CropImageModal } from "./CropImageModal";

export const PaziaCropDropzone = ({ name, label, onFileToLarge }: PaziaFileDropzoneProps) => {
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const { setValue, getValues } = useFormContext();
  const [imageSrc, setImageSrc] = React.useState<string | null>(null);

  const onFileChange = async (file: File) => {
    let imageDataUrl = await readFile(file);
    setImageSrc(imageDataUrl);
    setIsCropModalOpen(true);
  };

  const onConfirm = (file: File, blobUrl: string) => {
    setValue(name, file, { shouldDirty: true });
    closeModal();
  };

  const closeModal = () => {
    setIsCropModalOpen(false);
    setImageSrc(null);
  };

  return (
    <>
      <PaziaFileDropzone
        name={name}
        label={label}
        type="image"
        single
        preview="image"
        onDrop={onFileChange}
        onFileToLarge={onFileToLarge}
      />
      <CropImageModal onConfirm={onConfirm} onCloseRequest={closeModal} isOpen={isCropModalOpen} imageSrc={imageSrc} />
    </>
  );
};

interface PaziaFileDropzoneProps {
  name: string;
  required?: boolean;
  label?: string;
  multiple?: boolean;
  single?: boolean;
  preview?: "image" | "file";
  onFileToLarge?: () => void;
}
